import { useMemo, useCallback, useEffect } from "react";
import { useAppSelector, useAppDispatch } from "@/store";
import { fetchLogin, fetchGetOrgs, fetchUserInfo } from "@/store/modules/app";
import { userParmas } from "@/facilities/model/user";
import { AuthContext } from "./authContext";
import i18n from "@/i18n/config";
import { ConfigProvider, App, theme } from "antd";

export default function AuthProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const dispatch = useAppDispatch();
  const {
    role,
    roles,
    isLogin,
    theme: darkMode,
    userName: user,
  } = useAppSelector((state) => state.app);

  const signin = useCallback(
    async (params: userParmas) => {
      const { payload } = await dispatch(fetchLogin({ params }));
      return payload;
    },
    [dispatch]
  );

  useEffect(() => {
    console.log(
      "%cFUSION-TMS",
      "font-size: 20px; color: #fff; background: linear-gradient(90deg, #2489e3, #2c9cf0); padding: 10px;"
    );
    if (isLogin && !roles.length) {
      dispatch(fetchUserInfo());
      dispatch(fetchGetOrgs());
    }
  }, []);

  useEffect(() => {
    console.log(
      "%cCurrent user login state:",
      "color: #359C02;",
      isLogin,
      user,
      role
    );
  }, [isLogin, user, role]);

  useEffect(() => {
    document.body.classList.remove("dark");
    document.body.classList.remove("light");
    document.body.classList.add(darkMode);
  }, [darkMode]);

  const signout = useCallback(() => {}, []);

  const value = useMemo(
    () => ({ user, role, roles, signin, signout }),
    [role, user, roles, signin, signout]
  );

  return (
    <AuthContext.Provider value={value}>
      <ConfigProvider
        wave={{ disabled: true }}
        locale={{ locale: i18n.language }}
        theme={{
          token: {
            colorPrimary: "#0364FF",
            colorBorder: darkMode === "dark" ? "#ffffff21" : "#D9D9D9",
            borderRadius: 2,
            colorError: "#D12730",
          },
          components: {
            Switch: {
              trackHeight: 24,
              trackPadding: 4,
              trackMinWidth: 40,
              handleSize: 16,
            },
          },
          algorithm: darkMode === "dark" ? [theme.darkAlgorithm] : [],
        }}
      >
        <App>{children}</App>
      </ConfigProvider>
    </AuthContext.Provider>
  );
}
